import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { Flex } from '../atom/Layout';
import Icon from '../atom/Icon';
import { Text } from '../atom/Text';
import Evaluation from '../molecules/Evaluation';
import { TextLink } from '../molecules/TextLink';
import { SocialShareIconButton } from './SocialShare';

import * as PATH from '../../../lib/routes/path';
import ReviewContext from '../../../modules/contexts/Review';
import ThemeStyle from '../../../lib/style/ThemeStyle';

const SmallReviewCard = ({
  id,
  storageUri,
  userName,
  createDateTime,
  likesCount,
  reviewText,
  star,
}) => {
  return (
    <Container column>
      <Link
        to={`${PATH.REVIEW_DETAIL}/${id}`}
        style={{
          display: 'flex',
          alignItems: 'center',
          overflow: 'hidden',
          background: ThemeStyle.background.grey,
          width: '14.063rem',
          height: '14.063rem',
        }}
      >
        {storageUri !== '' && (
          <img
            src={storageUri}
            alt="리뷰 이미지"
            width="100%"
            height="100%"
            style={{ objectFit: 'cover' }}
          />
        )}
      </Link>
      <ReviewCard
        userName={userName}
        createDateTime={createDateTime}
        star={star}
        likesCount={likesCount}
        id={id}
      >
        <Text
          size={12}
          color="black"
          style={{
            width: '100%',
            height: '2.313rem',
            marginTop: '0.75rem',
          }}
        >
          {reviewText.substring(0, 36)}
          <TextLink
            link={`${PATH.REVIEW_DETAIL}/${id}`}
            color="brownGrey"
            size={12}
          >
            ...더 보기
          </TextLink>
        </Text>
      </ReviewCard>
    </Container>
  );
};

export default SmallReviewCard;

const Container = styled(Flex)`
  width: 14.063rem;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
`;

export const ReviewCard = ({
  userName,
  createDateTime,
  star,
  likesCount,
  id,
  text,
  imageUrl,
  children,
}) => {
  const { state, actions } = useContext(ReviewContext);
  const [nextLikesCount, setNextLikesCount] = useState(likesCount);
  return (
    <Flex column width={`calc(100% - 0.625rem)`} padding="0.625rem 0 1.25rem">
      <Flex justifyContent="space-between" style={{ width: '100%' }}>
        <div>
          <Text size={12} color="caption">
            {`${userName.slice(0, -1)}*`}
          </Text>
          <Text size={12} color="brownGrey" style={{ marginLeft: '0.313rem' }}>
            {createDateTime}
          </Text>
        </div>
        <SocialShareIconButton
          params={{
            url: `https://www.babyface.io${PATH.REVIEW_DETAIL}/${id}`,
            title: '베이비페이스 리뷰',
            text,
            imageUrl,
          }}
        />
      </Flex>
      <Flex
        justifyContent="space-between"
        padding="0.313rem 0"
        style={{ width: '100%' }}
      >
        <Flex>
          <Evaluation star={star} />
        </Flex>
        <Flex>
          <Icon
            iconName="thumb_up"
            style={{
              color: state.likeItems.includes(id)
                ? ThemeStyle.color.orangePink
                : '#7a7d86',
            }}
            onClick={() => {
              state.likeItems.includes(id)
                ? actions.onUnlike(id)
                : actions.onLike(id);
              state.likeItems.includes(id)
                ? setNextLikesCount(nextLikesCount - 1)
                : setNextLikesCount(nextLikesCount + 1);
            }}
          />
          <Text color="brownGrey" size={12} style={{ marginLeft: '0.313rem' }}>
            {nextLikesCount}
          </Text>
        </Flex>
      </Flex>
      {children}
    </Flex>
  );
};
